import Axios from 'axios';
import {
    ICheqeuResponse,
    IChequeDelivery,
    IGetCheqeuRequest,
    IUpdateCheque,
    IValidateCheqeuRequest,
    IValidationChequeResponse,
} from '../models/cheque.model';
import { ApiResultModel, IReferenceKey } from '../models/common.model';
import { APIBASE_URL, CHEQUE_URL } from '../config/cacheKey';

export const GetCheques = async (
    data: IGetCheqeuRequest
): Promise<ICheqeuResponse[]> => {
    return await Axios.post<ApiResultModel<ICheqeuResponse[]>>(
        APIBASE_URL + CHEQUE_URL + '/Get',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const UpdateCheque = (data: IUpdateCheque): Promise<ICheqeuResponse> => {
    const formData = new FormData();
    formData.append('chequeId', String(data.chequeId!));
    formData.append('sayadNumber', data.sayadNumber!);
    formData.append('referenceKey', data.referenceKey!);
    if (data.frontImage !== null) {
        formData.append('frontImage', data.frontImage!, data.frontImage?.name);
    }
    if (data.rearImage !== null) {
        formData.append('rearImage', data.rearImage!, data.rearImage?.name);
    }
    return Axios.post<ApiResultModel<ICheqeuResponse>>(
        APIBASE_URL + CHEQUE_URL + '/Update',
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data; charset=utf-8',
            },
        }
    ).then((result) => {
        return result.data.data;
    });
};

export const GetChequesForDelivery = async (
    data: IReferenceKey
): Promise<IChequeDelivery> => {
    return await Axios.post<ApiResultModel<IChequeDelivery>>(
        APIBASE_URL + CHEQUE_URL + '/GetChequesForDelivery',
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const ValidateCheque = async (
    data: IValidateCheqeuRequest
): Promise<IValidationChequeResponse[]> => {
    return await Axios.post<ApiResultModel<IValidationChequeResponse[]>>(
        APIBASE_URL + CHEQUE_URL + '/Validate',
        data
    ).then((result) => {
        return result.data.data;
    });
};
